import Client from './Client';

export default class AdvertisingClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取广告列表
   */
  async getList(data) {
    const res = await this.client.post('/api/advertising/page', data);
    return res;
  }

  /**
   * 获取详情
   */
  async getInfo(data) {
    const res = await this.client.post('/api/advertising/get', data);
    return res;
  }

  /**
   * updateValid
   * @param
   * id
   */
  async updateValid(data) {
    const res = await this.client.post('/api/advertising/updateValid', data);
    return res;
  }

  /**
   * 新增修改
   * @param
   * id
   */
  async advertisingUpsert(data) {
    const res = await this.client.post('/api/advertising/upsert', data);
    return res;
  }

  /**
   * 重置排序
   *
   */
  async resetRank(data) {
    const res = await this.client.post('/api/advertising/resetRank', data);
    return res;
  }
}